import axios from 'axios';

export const trimTextForPreview = (string, max = 24) => {
    const words = string.split(' ');
    if (words.length <= max) {
        return string.trim();
    }

    return `${words.slice(1, max).join(' ').trim()}...`;
};

export const loadEmailDraft =  (draftId) => {
    //console.log('loadEmailDraft draftId =>', draftId);
    return axios({
        method: 'get',
        url: `/api/v3/email_draft/${draftId}`,
        baseURL: process.env.REACT_APP_API_ROOT,
    })
    .then((response) => {
        //console.log('loadEmailDraft response =>', response);
        return response.data.data;
    })
    .catch((error) => {
        if (error.response && error.response.data) {
            throw error.response.data;
        }
        throw error;
    })
}

// Keeps a mail iframe as high as its content. Measuring once on load is not
// enough: (embedded) images may finish rendering later and a width change
// re-wraps the text, both cut off the end of the mail.
export const handleMailIframeLoad = (event) => {
    const iframe = event.currentTarget;
    const doc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!doc || !doc.body) {
        return;
    }

    // otherwise the bottom margin of the last element collapses out of the body
    // and is missing in body.scrollHeight
    doc.body.style.display = 'flow-root';
    const updateHeight = () => {
        iframe.style.height = `${doc.body.scrollHeight}px`;
    };

    if (iframe.mailResizeObserver) {
        iframe.mailResizeObserver.disconnect();
    }
    if (typeof ResizeObserver !== 'undefined') {
        iframe.mailResizeObserver = new ResizeObserver(updateHeight);
        iframe.mailResizeObserver.observe(doc.body);
    }
    Array.from(doc.images).forEach((img) => img.addEventListener('load', updateHeight));
    updateHeight();
};

// The server (PHP post_max_size / ValidatePostSize) rejects the request with 413,
// e.g. if the body contains large pasted (base64) images
export const isPayloadTooLargeError = (error) =>
    error?.status === 413 ||
    error?.response?.status === 413 ||
    error?.exception === 'Illuminate\\Http\\Exceptions\\PostTooLargeException';

export const PAYLOAD_TOO_LARGE_MESSAGE =
    'Die E-Mail ist zu groß. Bitte eingefügte Bilder verkleinern oder entfernen bzw. als Anhang hinzufügen.';

export const createOrUpdateEmailDraft =  (data) => {
    //console.log('createOrUpdateEmailDraft data =>', data);
    return axios({
        method: 'post',
        url: '/api/v3/email_draft/create_or_update',
        baseURL: process.env.REACT_APP_API_ROOT,
        data: data==null ? {} : data,
    })
    .then((response) => {
        //console.log('createOrUpdateEmailDraft response =>', response);
        return response.data;
    })
    .catch((error) => {
        if (error.response && error.response.data) {
            throw Object.assign(new Error(error.response.data.message || error.message), {
                ...error.response.data,
                status: error.response.status,
            });
        }
        throw error;
    })
};

export const deleteEmailDraft =  (draftId) => {
    //console.log('deleteEmailDraft draftId =>', draftId);
    return axios({
        method: 'delete',
        url: `/api/v3/email_draft/${draftId}`,
        baseURL: process.env.REACT_APP_API_ROOT,
    })
    .then((response) => {
        //console.log('deleteEmailDraft response =>', response);
        return response.data;
    })
    .catch((error) => {
        if (error.response && error.response.data) {
            throw error.response.data;
        }
        throw error;
    })
};